import { DropdownModel } from "./../../report/models/report-filter.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  NgZone
} from "@angular/core";
import {
  IKeyValueInterface,
  BookingStatus,
  Permission,
  PermissionType,
  WeGoAuthorizedLink,
  Entity
} from "./../../shared/config";
import { Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL
} from "../../shared/config";

import { VatSettingsModel } from "../../vat-setting/models/vat-settings.model";
import { BookingService } from "../../booking/models/booking.service";
import { CostAndExpenseService } from "../../cost-expenses/models/cost-expense.service";
import { CostAndExpenseModel } from "../../cost-expenses/models/cost-expense.model";

const moment = require("moment");

@Component({
  selector: "confirm-costandexpense-driver-popup",
  template: require('../views/confirm-costandexpense-driver-popup.component.html'),
  providers: [CostAndExpenseService, BookingService],
  styles: [
    `
      .form-horizontal .control-label {
        text-align: left;
      }
      .image-expense {
            max-width: 100%;
            max-height: 350px;
      }
      .overlay-magnifier {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        background: rgba(0,0,0,0.2);
        align-items: center;
        justify-content: center;
      }
    `
  ]
})
export class ConfirmCostAndExpenseDriverComponent implements OnInit {
  urlBookingInfo: string;
  viewBookingLink: WeGoAuthorizedLink;
  urlPersonInfo: string;
  viewPersonLink: any;
  _model: CostAndExpenseModel;

  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;

  @ViewChild("approvalCostAndExpenseModel") approvalCostAndExpenseModel: any;
  @ViewChild("receiptImagePopup") receiptImagePopup: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private zone: NgZone,
    private costAndExpenseService: CostAndExpenseService,
    private bookingService: BookingService
  ) {}

  @Input()
  set model(_costAndExpenseModel: CostAndExpenseModel) {
    this._model = _costAndExpenseModel;
  }
  get model() {
    return this._model;
  }

  ngOnInit() {
    this.urlPersonInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );

    this.urlBookingInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
  }

  public show(): void {
    this.errorMsg = "";
    this.errorModel = [];
    this.viewPersonLink = new WeGoAuthorizedLink(
      this.urlPersonInfo + "/" + this.model.reportedByPersonHashId,
      Permission.PR_PERSON_OVERVIEW,
      PermissionType.EDIT,
      "",
      this.model.reportedByName,
      "",
      "",
      true
    );

    this.viewBookingLink = new WeGoAuthorizedLink(
      this.urlBookingInfo + "/" + this.model.bookingHashId,
      Permission.PR_BOOKINGS_OVERVIEW,
      PermissionType.VIEW,
      "",
      this.model.bookingReferenceID,
      "",
      "",
      true
    );

    this.approvalCostAndExpenseModel.show();
  }

  public hide(): void {
    this.model = new CostAndExpenseModel();
    this.approvalCostAndExpenseModel.hide();
  }

  public GetImagePath(path: string) {
    return WeGoConfig.API_SERVER_URL + path;
  }

  public ShowReceipt(imagepath: string) {
    this.receiptImagePopup.imagepath = imagepath;
    this.receiptImagePopup.show();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/cost-expenses-driver/components/confirm-costandexpense-driver-popup.component.ts